<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M19.9987 5.33333H21.332C24.2775 5.33333 26.7338 7.75823 26.0071 10.6127C25.5037 12.59 24.7241 14.457 23.7118 16.1702L19.7727 12.2316L17.747 10.2058C18.1849 9.09088 18.477 7.90262 18.5997 6.66456C18.6724 5.93177 19.2623 5.33333 19.9987 5.33333Z"
            fill="#7A70DF"/>
        <path
            d="M5.33203 21.3333V20C5.33203 19.2636 5.93047 18.6737 6.66325 18.601C7.90131 18.4783 9.08957 18.1862 10.2045 17.7483L12.2302 19.774C13.8777 18.9856 15.3692 17.9236 16.6459 16.6468L20.4172 20.4181C17.7507 23.0846 14.3816 25.0486 10.6114 26.0084C7.75693 26.7351 5.33203 24.2789 5.33203 21.3333Z"
            fill="#7A70DF"/>
        <path d="M5.33203 5.33333L26.6654 26.6667" stroke="#7A70DF" stroke-linecap="round"/>
    </svg>
</template>
